__turbopack_context__.v({
  "avatar": "pWgxEW_avatar",
});
